import {httpClient} from "../../service";
import {Button, Form} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import { HttpMethod} from "../../model";
import {TtaSecModel} from '../verifications/VerifyConfigModel';

const T3Detail = (props: any) => {
    const item: TtaSecModel = props.item;
    //const custNo = props.custNo;

    const [entity, setEntity] = useState<TtaSecModel>(item);
    const [loading, setLoading] = useState<boolean>(false);

    const doProcess = async (e: any) => {
        e.preventDefault();
        console.log(`click button id=${e.target}`);
        setLoading(true);
        const url = `test/tta3`;
        const options = {
            method: HttpMethod.POST,
            url,
            body: entity
        }
        const act = await httpClient(options);
        setLoading(false);
        if (act.result) {
            const data: TtaSecModel = act.data;
            setEntity({
                ...entity,
                id: data.id,
                rscore: data.rscore,
                fscore: data.fscore,
                mscore: data.mscore,
                rfmScore: data.rfmScore,
                couponId: data.couponId,
                couponNm: data.couponNm,
                result: data.result,
                resultMsg: data.resultMsg
            });
        } else {
            alert(act.errorMsg);
        }
    }

    let resultMsg = '';
    useEffect(() => {
        resultMsg = '검증전';
        if (item.id) {
            console.log(`id:${item.id},difSec=${item.difSec}`);
        }

    }, [item.idx]);

    if (entity.id) {
        if (entity.id > 0) {
            resultMsg = entity.result === true ? '성공' : '실패';
        } else {
            resultMsg = '검증전';
        }
    } else {
        resultMsg = '검증전';
    }
    const handleInputChange = (e: any) => {
        console.log(`name=${e.target.name}, value=${e.target.value}`);
        const data = {...entity, [e.target.name]: e.target.value};
        setEntity(data);
    }
    const setResultMsg = () => {
        return entity.result === true ? (`RFM Score: ${entity.rfmScore}<br />쿠폰명: ${entity.couponNm}`) : ('N/A');
    }
    return (

        <>
            <tr>
                <td>{item.idx}</td>
                <td>
                    <Form.Group className={'mb-0'}>
                        <Form.Control name="rn" required onChange={handleInputChange} value={entity.rn}/>
                    </Form.Group>
                </td>
                <td>
                    <Form.Group className={'mb-0'}>
                        <Form.Control name="fn" required onChange={handleInputChange} value={entity.fn}/>
                    </Form.Group>
                </td>
                <td>
                    <Form.Group className={'mb-0'}>
                        <Form.Control name="ap" required onChange={handleInputChange} value={entity.ap}/>
                    </Form.Group>
                </td>
                <td>
                    <Button className="btn-primary" size="sm" onClick={doProcess} disabled={loading}
                            style={{width: '80px'}}>적용하기</Button>
                </td>
                <td>{entity.rscore}</td>
                <td>{entity.fscore}</td>
                <td>{entity.mscore}</td>
                <td>{entity.rfmScore}</td>
                <td>{entity.result === true ? ('발송') : (`${entity.id ? entity.resultMsg : ''}`)}</td>
                <td>
                    <div dangerouslySetInnerHTML={{__html: setResultMsg()}}></div>
                </td>
                <td>
                    {resultMsg}
                </td>
            </tr>

        </>
    )
}
export default T3Detail;
